
export const products = [
  {
    id: 1,
    name: '夢幻繡球混合花束',
    price: 3600,
    image: 'https://static.readdy.ai/image/4f3f06d226654fda02a3ba64a379f0f2/6caad0e0afe8ed90495230c3a31cc4df.jpeg',
    description: '精選繡球花與季節花材的完美組合，展現優雅浪漫氛圍'
  },
  {
    id: 2,
    name: '琴葉榕盆栽',
    price: 2800,
    image: 'https://public.readdy.ai/ai/img_res/74d4d70bac3bff33c3a73c5ec6536d6b.jpg',
    description: '大型觀葉植物，寬大的琴葉形葉片，為空間增添自然綠意'
  },
  {
    id: 3,
    name: '天堂鳥盆栽',
    price: 3200,
    image: 'https://readdy.ai/api/search-image?query=beautiful%20bird%20of%20paradise%20plant%20in%20elegant%20white%20pot%20on%20clean%20background%2C%20large%20tropical%20green%20leaves%2C%20modern%20indoor%20plant%20arrangement%2C%20professional%20botanical%20photography%2C%20soft%20natural%20lighting%2C%20high-end%20plant%20boutique%20style%2C%20sophisticated%20presentation&width=400&height=500&seq=monceau-green-bird-002&orientation=portrait',
    description: '熱帶風情觀葉植物，葉片挺拔優雅，適合明亮空間擺設'
  },
  {
    id: 4,
    name: '橡皮樹盆栽',
    price: 2500,
    image: 'https://readdy.ai/api/search-image?query=rubber%20plant%20with%20glossy%20dark%20green%20leaves%20in%20modern%20white%20ceramic%20pot%20on%20clean%20white%20background%2C%20elegant%20indoor%20plant%20styling%2C%20professional%20nursery%20photography%2C%20natural%20soft%20lighting%2C%20minimalist%20botanical%20presentation%2C%20high-end%20plant%20shop%20quality&width=400&height=500&seq=monceau-green-rubber-003&orientation=portrait',
    description: '深綠色光澤葉片，易於照顧的室內綠植，淨化空氣好幫手'
  },
  {
    id: 5,
    name: '經典玫瑰花束',
    price: 2800,
    image: 'https://readdy.ai/api/search-image?query=elegant%20premium%20red%20roses%20bouquet%20with%20luxury%20wrapping%20paper%20on%20clean%20white%20background%2C%20professional%20florist%20arrangement%2C%20high-end%20flower%20shop%20style%2C%20soft%20natural%20lighting%2C%20minimalist%20composition%2C%20sophisticated%20floral%20design&width=400&height=500&seq=monceau-roses-001&orientation=portrait',
    description: '永恆經典的紅玫瑰，傳遞最真摯的情感與祝福'
  },
  {
    id: 6,
    name: '繡球花禮盒',
    price: 3200,
    image: 'https://readdy.ai/api/search-image?query=beautiful%20hydrangea%20flowers%20in%20elegant%20gift%20box%20with%20luxury%20packaging%2C%20premium%20florist%20arrangement%2C%20clean%20white%20background%2C%20soft%20pastel%20colors%2C%20high-end%20flower%20boutique%20style%2C%20natural%20lighting%2C%20sophisticated%20presentation&width=400&height=500&seq=monceau-hydrangea-002&orientation=portrait',
    description: '精緻禮盒包裝，適合送禮表達心意的最佳選擇'
  },
  {
    id: 7,
    name: '法式鬱金香組合',
    price: 2500,
    image: 'https://readdy.ai/api/search-image?query=french%20style%20tulips%20arrangement%20in%20premium%20wrapping%2C%20elegant%20flower%20bouquet%20on%20clean%20white%20background%2C%20luxury%20florist%20design%2C%20soft%20natural%20colors%2C%20high-end%20boutique%20presentation%2C%20minimalist%20sophisticated%20style&width=400&height=500&seq=monceau-tulips-003&orientation=portrait',
    description: '優雅的鬱金香搭配法式包裝，展現純粹的浪漫美學'
  },
  {
    id: 8,
    name: '季節花藝設計',
    price: 3800,
    image: 'https://readdy.ai/api/search-image?query=seasonal%20mixed%20flowers%20arrangement%20with%20premium%20wrapping%2C%20luxury%20florist%20bouquet%20on%20clean%20white%20background%2C%20elegant%20floral%20design%2C%20soft%20natural%20lighting%2C%20high-end%20flower%20shop%20style%2C%20sophisticated%20composition&width=400&height=500&seq=monceau-seasonal-004&orientation=portrait',
    description: '依季節精選花材，每一束都是獨一無二的藝術創作'
  },
  {
    id: 9,
    name: '白色優雅系列',
    price: 3500,
    image: 'https://readdy.ai/api/search-image?query=elegant%20white%20flowers%20bouquet%20with%20luxury%20packaging%2C%20premium%20florist%20arrangement%20on%20clean%20background%2C%20sophisticated%20monochrome%20floral%20design%2C%20soft%20natural%20lighting%2C%20high-end%20boutique%20style%2C%20minimalist%20presentation&width=400&height=500&seq=monceau-white-005&orientation=portrait',
    description: '純白花藝系列，簡約而不失優雅，適合各種場合'
  },
  {
    id: 10,
    name: '粉色浪漫花束',
    price: 2900,
    image: 'https://readdy.ai/api/search-image?query=romantic%20pink%20flowers%20bouquet%20with%20elegant%20wrapping%20paper%2C%20premium%20florist%20arrangement%20on%20clean%20white%20background%2C%20soft%20pastel%20colors%2C%20luxury%20flower%20shop%20style%2C%20natural%20lighting%2C%20sophisticated%20design&width=400&height=500&seq=monceau-pink-006&orientation=portrait',
    description: '柔美粉色調花束，傳遞溫柔浪漫的心意'
  },
  {
    id: 11,
    name: '向日葵陽光組合',
    price: 2600,
    image: 'https://readdy.ai/api/search-image?query=bright%20sunflowers%20arrangement%20with%20premium%20wrapping%2C%20elegant%20florist%20bouquet%20on%20clean%20white%20background%2C%20cheerful%20yellow%20flowers%2C%20luxury%20boutique%20style%2C%20natural%20lighting%2C%20sophisticated%20presentation&width=400&height=500&seq=monceau-sunflower-007&orientation=portrait',
    description: '充滿活力的向日葵，為生活帶來陽光般的溫暖'
  },
  {
    id: 12,
    name: '奢華混合花禮',
    price: 4500,
    image: 'https://readdy.ai/api/search-image?query=luxurious%20mixed%20flowers%20arrangement%20in%20premium%20gift%20box%2C%20high-end%20florist%20design%20on%20clean%20background%2C%20elegant%20floral%20composition%2C%20soft%20natural%20lighting%2C%20sophisticated%20boutique%20style%2C%20expensive%20flower%20presentation&width=400&height=500&seq=monceau-luxury-008&orientation=portrait',
    description: '頂級花材組合，展現極致奢華的花藝美學'
  }
];
